"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.match");require("core-js/modules/es6.function.name");




































































































































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter");
var _aliOss = _interopRequireDefault(require("@/utils/aliOss")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      imageList: [], newadd: false, name: '', title: '新增', searchData: { name: '', mobile: '', codeType: '', code: '', sex: '', insId: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', name: '', mobile: '', password: '', codeType: '', code: '', sex: '', birthDate: '', userId: '', image: '' }, rules: { name: [{ required: true, message: '请输入姓名', trigger: 'blur' }], password: [{ required: true, message: '请输入密码', trigger: 'blur' }], mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }], sex: [{ required: true, message: '请选择性别', trigger: 'blur' }], code: [{ required: true, message: '请输入编号', trigger: 'blur' }], codeType: [{ required: true, message: '请选择编号类型', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'name', label: '名称', isShow: true }, { prop: 'mobile', label: '手机号', isShow: true }, { prop: 'password', label: '密码', isShow: true }, { prop: 'sex', label: '性别', formatter: function formatter(row, column, val) {return val === 1 ? '男' : '女';}, isShow: false }, { prop: 'codeType', label: '编码类型', formatter: function formatter(row, column, val) {return val === 1 ? '工号' : '学号';}, isShow: false }, { prop: 'code', label: '编号', isShow: true }, { prop: 'birthDate', label: '出生日期', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: false }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: false }] };}, mounted: function mounted() {var self = this;var orgId = self.$route.query.orgId;if (orgId) {self.searchData.insId = orgId;}self.init();}, methods: { init: function init() {var self = this;self.getData('/api/temi/employee', self.searchData, function (res) {console.log(res);self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.name = '';this.searchData.mobile = '';this.searchData.codeType = '';this.searchData.code = '';this.searchData.sex = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, addFun: function addFun() {// 新增
      this.name = '新增';this.title = '新增';this.newadd = true;this.cleanData();}, closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();this.cleanData();this.newadd = false;this.onCencal();}, updateMenu: function updateMenu(item) {// 修改操作
      this.name = '修改';this.title = '修改';var self = this;self.newadd = true;self.addData = { id: item.id, name: item.name, mobile: item.mobile, password: item.password, sex: item.sex + '', codeType: item.codeType + '', code: item.code, birthDate: item.birthDate };}, onSubmit: function onSubmit() {// 新增提交操作
      var self = this;self.$refs.addForm.validate(function (valid) {if (valid) {self.postData('/api/temi/employee', self.addData, function (res) {self.$message({ message: '添加成功!', type: 'success' });self.onCencal();self.searchData.page = 1;self.init();});} else {return false;
        }
      });
    },
    onUpdate: function onUpdate() {//修改提交操作
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/temi/employee?id=' + self.addData.id, self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/temi/employee?id=' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.newadd = false;
      this.$refs.addForm.resetFields();
      this.cleanData();
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        name: '',
        mobile: '',
        password: '',
        sex: '',
        codeType: '',
        code: '',
        birthDate: '' };

    },
    getFile: function getFile(event) {
      this.addData.excelFile = event.target.files[0];
    },
    importExcel: function importExcel(item) {
      this.title = '导入Excel';
      this.newadd = true;
      // this.addData = JSON.parse(JSON.stringify(item))
    },
    onImport: function onImport(event) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          var File = new FormData();
          File.append('excelFile', self.addData.excelFile);
          self.postData('/api/temi/employee/batch', File, function (res) {
            self.$message({
              message: '导入成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    entryMenu: function entryMenu(item) {//人脸录入操作
      this.title = '录入人脸';
      var self = this;
      self.newadd = true;
      console.log('item', item);
      self.addData.userId = item.userId;
      console.log('self.addData.userId', self.addData.userId);
    },
    getBase64: function getBase64(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
      var dataURL = canvas.toDataURL("image/" + ext);
      return dataURL;
    },
    fnUploadRequest: function fnUploadRequest(option) {
      var path = 'robot/face';
      _aliOss.default.ossUploadFile(option, path);
    },
    beforeRemove: function beforeRemove(file, fileList) {
      console.log(file);
      var fileName = file.name;
      var confirm = '确定移除' + fileName + '？';
      return this.$confirm(confirm);
    },
    handleOnRemove: function handleOnRemove(file, fileList) {
      this.addData.image = '';
      this.$message('移除' + file.name + '成功');
    },
    onsuccess: function onsuccess(res) {
      var self = this;
      var imageUrl = 'https://cdn-tech.cozzia.com.cn/' + res.name;
      var image = new Image();
      image.crossOrigin = '';
      image.src = imageUrl;
      image.onload = function () {
        var base64 = self.getBase64(image);
        self.addData.image = base64;
      };

    },
    EntryBtn: function EntryBtn() {// 人脸录入提交操作
      var self = this;
      var base64Str = self.addData.image.match(/base64,(\S*)/);
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/temi/employee/bandFace', {
            employeeUserId: self.addData.userId,
            image: base64Str[1] },
          function (res) {
            self.$message({
              message: '录入成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    } } };exports.default = _default;